import React, { useState } from 'react';
import { api } from '../api';

function Settings({ user }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    setLoading(true);

    try {
      await api.changePassword({
        current_password: currentPassword,
        new_password: newPassword
      });

      setSuccess('Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      setError(error.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Account Settings</h1>
      </div>

      <div style={{ maxWidth: '600px' }}>
        <div className="card">
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
            Account Information
          </h2>
          <p style={{ fontSize: '0.875rem', color: 'hsl(var(--muted-foreground))', marginBottom: '1.5rem' }}>
            Manage your account settings and change your password
          </p>

          <div style={{ marginBottom: '1.5rem', padding: '1rem', background: 'hsl(var(--surface-2))', borderRadius: '0.5rem' }}>
            <div style={{ fontSize: '0.75rem', color: 'hsl(var(--muted-foreground))', marginBottom: '0.25rem' }}>
              Email Address
            </div>
            <div style={{ fontSize: '0.875rem', fontWeight: '500' }}>{user.email}</div>
          </div>

          <div style={{ marginBottom: '1.5rem', padding: '1rem', background: 'hsl(var(--surface-2))', borderRadius: '0.5rem' }}>
            <div style={{ fontSize: '0.75rem', color: 'hsl(var(--muted-foreground))', marginBottom: '0.25rem' }}>
              Role
            </div>
            <div style={{ fontSize: '0.875rem', fontWeight: '500', textTransform: 'capitalize' }}>
              {user.role === 'super_admin' ? 'Super Admin' : 'Tenant Admin'}
            </div>
          </div>

          {user.tenant_name && (
            <div style={{ marginBottom: '1.5rem', padding: '1rem', background: 'hsl(var(--surface-2))', borderRadius: '0.5rem' }}>
              <div style={{ fontSize: '0.75rem', color: 'hsl(var(--muted-foreground))', marginBottom: '0.25rem' }}>
                Company
              </div>
              <div style={{ fontSize: '0.875rem', fontWeight: '500' }}>{user.tenant_name}</div>
            </div>
          )}

          <hr style={{ margin: '2rem 0', border: 'none', borderTop: '1px solid hsl(var(--border))' }} />

          <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1rem' }}>
            Change Password
          </h3>

          {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}
          {success && (
            <div style={{ padding: '0.75rem 1rem', background: 'hsl(120, 60%, 20%)', color: 'hsl(120, 100%, 80%)', borderRadius: '0.375rem', marginBottom: '1rem', fontSize: '0.875rem' }}>
              {success}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Current Password</label>
              <input
                type="password"
                className="form-input"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                disabled={loading}
                data-testid="input-current-password"
              />
            </div>

            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading}
                placeholder="At least 6 characters"
                data-testid="input-new-password"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input
                type="password"
                className="form-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
                data-testid="input-confirm-password"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              data-testid="btn-change-password"
            >
              {loading ? 'Changing Password...' : 'Change Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Settings;
